import { RaviWidget } from '@/modules/rate-and-review';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useMemo } from 'react';

export const FragmentRateReview = ({ profileData }: { profileData: any }) => {
  const dontShowRateDetails = useFeatureIsOn('ravi_show_external_rate');

  const centers = useMemo(
    () =>
      (profileData?.centers ?? [])
        .filter((center: { id?: unknown; name?: string }) => center?.id && center?.name)
        .map((center: { id: unknown; name: string }) => ({
          id: String(center.id),
          name: center.name,
        })),
    [profileData?.centers],
  );

  return (
    <div className="flex flex-col space-y-1">
      <RaviWidget
        doctorSlug={profileData.seo.slug}
        doctorUserId={profileData?.information?.id != null ? String(profileData.information.id) : undefined}
        displayName={profileData?.information?.display_name}
        centers={centers}
        hideSummary={dontShowRateDetails}
      />
    </div>
  );
};
